// extracted by mini-css-extract-plugin
export default {"wrapper":"iC-z","button":"jC-z","alternate":"kC-z","disabled":"lC-z","paymentWarning":"mC-z","fadeIn":"nC-z"};